export default "__VITE_ASSET__CF5W5a7l__"